const ENRiskClassification = {
	"Classificação de Risco" : "Risk Classification",
	"Nova Classificação de Risco" : "New Risck Classification",
	"Selecione..." : "Select...",
	"Aplicar filtro" : "Apply filters",
	"Limpar filtros" : "Clear filters",
	"Classificação de Risco excluído com sucesso" : "Risk Classification successfully removed",
	"Classificação de Risco adicionado com sucesso" : "Risk Classification successfully add",
	"Classificação de Risco alterado com sucesso" : "Risk Classification successfully altered",
	"Erro ao adicionar a Classificação de Risco" : "Error in adding Risk Classification",
	"Erro ao excluir a Classificação de Risco" : "Error in removing Risk Classification",
	"Erro ao alterar a Classificação de Risco" : "Error in altering Risk Classification",
	"Exclusão da Classificação de Risco" : "Exclude Risk Classification",
	"Deseja realmente excluir a Classificação de Risco" : "Do you wish to exclude this Risk Classification",
	"Digite a descrição da Classificação de Risco para excluí-lo" : "Type the Risk Classification description to exclude it",
	"Adicionar Classificação de Risco" : "Add Risk Classification",
	"Alterar Classificação de Risco" : "Alter Risk Classification",
	"Descrição da Classificação de Risco" : "Risk Classification Description"
};

export default ENRiskClassification;
